var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component"},[_c('router-view'),_c('modals-container'),_c('v-dialog',{staticClass:"content"}),_c('modal',{ref:"terms-and-conditions-modal",staticClass:"is-large",attrs:{"settings":{ title: 'Vendor Payments Disclaimer' }}},[_c('terms-and-conditions')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }